import { useEffect, useState } from "react";
import { QRStudioCard } from "./QRStudioCard";
import { AdminManagerPanel } from "./AdminManagerPanel";
import { getConfig, getVideo } from "../lib/api";

export const QrWorkspace = ({ qrId = "main" }) => {
  const [config, setConfig] = useState(null);
  const [video, setVideo] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadVideo = () => getVideo(qrId).then(setVideo).catch(() => {});

  useEffect(() => {
    setLoading(true);
    Promise.all([getConfig(qrId).then(setConfig).catch(() => {}), loadVideo()]).finally(
      () => setLoading(false)
    );
  }, [qrId]);

  return (
    <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
      <QRStudioCard config={config} loading={loading} qrId={qrId} />
      <AdminManagerPanel video={video} onChanged={loadVideo} qrId={qrId} />
    </div>
  );
};
